<template>
	<div :class="classObj" class="app-wrapper" id="appWrapper">
		<div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
		<sidebar class="sidebar-container" />
		<div :class="{hasTagsView:needTagsView}" class="main-container">
			<div :class="{'fixed-header':fixedHeader}">
				<navbar />
				<tags-view />
			</div>
			<app-main />
		</div>
		<!-- v-if="isAssistant" -->
		<!-- <div v-if="['zhate002', 'zhate001'].includes(userInfo.account)">
			<Knowledge v-show="StoreIsKnowledge" />
			<div v-show="!StoreIsKnowledge" v-drag id="knowledgeIcon" :style="{ top: top, left: left }">
				<svg-icon icon-class="knowledge" />
			</div>
		</div> -->
		<!-- <div v-dragDialog id="TelTransfer">
			<div class="konwledge-diog-header-cls"></div>
			<Keyboard :sipDriver="sipDriver" />
		</div> -->
	</div>
</template>

<script>
import Knowledge from '@/components/Knowledge';
import Help from '@/components/Help'
import Information from '@/components/Information'
import { AppMain, Navbar, /*Settings,*/ Sidebar, TagsView, } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState, mapActions, mapMutations } from 'vuex'
import SocketInstance from '@/im-server/socket-instance';
import Keyboard from '../components/Softphone/Keyboard';
import { sipInit } from '../components/Softphone/jsSipFun';

export default {
	name: 'Layout',
	components: {
		AppMain,
		Navbar,
		// Settings,
		Sidebar,
		Information,
		Help,
		TagsView,
		Knowledge,
		Keyboard
	},
	mixins: [ResizeMixin],
	computed: {
		...mapState({
			sidebar: state => state.app.sidebar,
			device: state => state.app.device,
			showSettings: state => state.settings.showSettings,
			needTagsView: state => state.settings.tagsView,
			fixedHeader: state => state.settings.fixedHeader,
			userInfo:state => state.user.userInfo,
			// StoreIsKnowledge: state => state.app.StoreIsKnowledge,
			// permission_routes: state => state.permission.routes
		}),
		classObj() {
			return {
				hideSidebar: !this.sidebar.opened,
				openSidebar: this.sidebar.opened,
				withoutAnimation: this.sidebar.withoutAnimation,
				mobile: this.device === 'mobile'
			}
		},
		// top() {
		// 	return (localStorage.getItem('assistant-icon-location-top') || '90%');
		// },
		// left() {
		// 	return (localStorage.getItem('assistant-icon-location-left') || '90%');
		// }
	},
	data() {
		return {
			// isAssistant: false,
			sipDriver: null
		}
	},
	methods: {
		...mapActions({
			setSocketToken: 'socket/setSocketToken',
			StoreGetApp: 'app/StoreGetApp',
			StoreKnowledgeAction: 'knowService/StoreKnowledgeAction'
		}),
		handleClickOutside() {
			this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
		},

		// 监听storage中的跳转，用来跨IFRAME跳转
		listenerStorage() {
			this.listenerRouterToHandler = window.addEventListener("storage", (e) => {
				if(e.key && e.key == 'routerTo' && e.newValue){
					this.routerTo();
				}
			})
		},
		routerTo() {
			let url = window.localStorage.getItem("routerTo");
			if (!url) return;
			this.$router.push({
				path: this.$store.getters["permission/getIframeMap"](url)
			})
			window.localStorage.removeItem("routerTo");
		},

		// 登录用户为品牌管理员时 请求子品牌 判断是否要新建子品牌
		checkSubBrand() {
			try{
				this.$store.commit("user/SET_NEED_CREATE_SUB_BRAND", false);
				if(this.userInfo.userType != 2) return;
				this.$api.getBrandSel({
				    data: {
				      parentBrandIdentify: this.userInfo.brandIdentify
				  },
				  orderBy: "",
				  pageNum: 1,
				  pageSize: 10
				}).then(res => {
				  if(!res) return false;
				  this.$store.commit("user/SET_NEED_CREATE_SUB_BRAND", res.list.length == 0);
				  if(res.list.length == 0){
				  	this.$confirm('请新建子品牌', '提示', {
	                    confirmButtonText: '去新建子品牌',
	                    cancelButtonText: '退出登录',
	                    type: 'info',
	                    showClose: false,
	                    closeOnClickModal: false,
	                    closeOnPressEscape: false
	                }).then(() => {
	                	this.$router.push({
	                		path: `/jurisdiction/brand`
	                	})
	                }).catch(() => {
	                    this.$store.dispatch('user/logout');
	                });
				  }
				})
			}catch(error){
				console.error(error);
			}
	    },
		initializeWs() {
			const params = {
				redirect: 'follow',
			}
			this.$api.getImServiceSocketToken(this.userInfo.userId, params).then(res => {
				this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS', {
					type: `获取socketToken`,
					content: `响应：${JSON.stringify(res)}`
				})
				if (res.errcode != 0) return;
				this.$store.commit('wsSocket/UPDATE_SOCKET_TOKEM', encodeURIComponent(res.data));
				SocketInstance.connect()
		
			});
		}
		
	},
	created() {
		this.sipDriver = sipInit();
		// setTimeout(() => {
		// 	for(const item of this.permission_routes) {
		// 		if(item.viewUrl === 'code://assistant') {
		// 			this.isAssistant = true;
		// 		}
		// 	}
		// }, 500);
	
		if(this.userInfo) {
			this.StoreGetApp(this.userInfo);
			this.StoreKnowledgeAction();
			this.initializeWs();
		}
	},
	mounted() {
	    this.checkSubBrand();
		this.listenerStorage();
		this.routerTo();
	},
	destroyed() {
		window.removeEvnetListener("storage", this.listenerRouterToHandler);
	}
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

#TelTransfer {
	background: darkmagenta;
	position: absolute;
	top: 93px;
	left: calc(100% - 300px);
	z-index: 3001;

	& .konwledge-diog-header-cls {
		width: 100%;
		height: 50px;
		background: darkorange;
		cursor: move;
	}
}

#knowledgeIcon {
	font-size: 68px;
	position: absolute;
	top: 90%;
	left: 90%;
	z-index: 2000;
	cursor: move;
	opacity: 0.3;

	&:hover {
		opacity: 1;
	}
}
.app-wrapper {
	@include clearfix;
	position: relative;
	height: 100%;
	width: 100%;

	&.mobile.openSidebar {
		position: fixed;
		top: 0;
	}
}

.drawer-bg {
	background: #000;
	opacity: 0.3;
	width: 100%;
	top: 0;
	height: 100%;
	position: absolute;
	z-index: 999;
	}

.fixed-header {
	position: fixed;
	top: 0;
	right: 0;
	z-index: 9;
	width: calc(100% - #{$sideBarWidth});
	transition: width 0.1s;
}

.hideSidebar .fixed-header {
	width: calc(100% - 54px)
}

.mobile .fixed-header {
	width: 100%;
}
</style>
